import { createContext } from 'react';

export const DataFetcherContext = createContext({});
